import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class TelaGrupoMenusService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  searchGrupos(data: any) {
    return this.http.get(API + '/accessProfile', { params: data });
  }

  searchGrupoById(data: any) {
    return this.http.get(API + '/accessProfile/' + data);
  }

  searchMenus(data: any) {
    return this.http.get(API + '/accessRole', { params: data });
  }

  searchMenusGrupo(data: any) {
    return this.http.get(API + '/accessRoleProfile', { params: data });
  }

  saveMenusGrupo(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/roleAccess', data, successHandle, errorHandle);
  }

  cadastrarProduto(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/accessProfile', data, successHandle, errorHandle);
  }
}
